<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="名称" prop="name" class="sj">
					<Input v-model="formValidate.name" placeholder="请输入名称"></Input>
				</FormItem>
				<FormItem label="备注" prop="remark" class="sj">
					<Input v-model="formValidate.remark" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem label="状态" prop="state" class="sj">
					<Select v-model="formValidate.state" placeholder="请选择状态">
						<Option value="true">启用</Option>
						<Option value="false">禁用</Option>
					</Select>
				</FormItem>
				<FormItem label="分类" prop="macKind" class="sj">
					<Select v-model="formValidate.macKind" placeholder="请选择状态">
						<Option value="SHJ">售货机</Option>
						<Option value="KFJ">咖啡机</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					id:"",
					name: '',
					remark: '',
					state: 'false',
					macKind:''
				},
				ruleValidate: {
					name: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}],
					state: [{
						required: true,
						message: '状态不能为空！！！',
						trigger: 'blur'
					}],
					
					macKind: [{
						required: true,
						message: '分类不能为空！！！',
						trigger: 'blur'
					}]

				},

			}
		},
		methods: {
			ret() {//返回上一页
				this.$router.go(-1)
			},
			 handleSubmit (name) {
				 let _this=this
                this.$refs[name].validate((valid) => {
                    if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/fac/mac/type/update',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
                        
                    } else {
                        this.$Message.error('请完善信息后再进行提交!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            },
			ajax(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/type/get',
				    data:{id:_this.formValidate.id},
					_this: _this,
					success: function(data) {
						_this.formValidate=data.macType
						if(data.macType.state==true){
							_this.formValidate.state="true"
						}else{
							_this.formValidate.state="false"
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
		created(){//请求数据
		    this.formValidate.id=this.$route.query.id
			this.ajax();
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/macType/update.vue